import { createDirectus, rest, authentication, login } from '@directus/sdk';

type DirectusData = any; // You can define a more specific type based on your data structure

class LocalStorage {
    get(): DirectusData | null {
        const data = localStorage.getItem("directus-data");
        if (!data) {
            window.location.href = '/login';
            return null;
        }
        return JSON.parse(data);
    }

    set(data: DirectusData): void {
        localStorage.setItem("directus-data", JSON.stringify(data));
    }
}

const storage = new LocalStorage();
const ip = process.env.VUE_APP_DIRECTUS_URL
export const directus = createDirectus(ip)
    .with(authentication('json', { storage }))
    .with(rest());
